exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* overridden by src/lib/themes/guiHelpers.js */\r\n\r\n.framerate-indicator_framerate-container_3JPah {\r\n    display: flex;\r\n    align-items: center;\r\n    padding: 0.25rem;\r\n    -webkit-user-select: none;\r\n       -moz-user-select: none;\r\n        -ms-user-select: none;\r\n            user-select: none;\r\n}\r\n\r\n.framerate-indicator_framerate-label_39miY {\r\n    font-size: 0.625rem;\r\n    font-weight: bold;\r\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\r\n    color: var(--control-primary);\r\n    white-space: nowrap;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"framerate-container": "framerate-indicator_framerate-container_3JPah",
	"framerateContainer": "framerate-indicator_framerate-container_3JPah",
	"framerate-label": "framerate-indicator_framerate-label_39miY",
	"framerateLabel": "framerate-indicator_framerate-label_39miY"
};